// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._39tcf{display:-ms-flexbox;display:flex;-ms-flex:1 0 100%;flex:1 0 100%;-ms-flex-direction:column;flex-direction:column;min-height:calc(100vh - 1.6rem)}.fhJQY{background:#036;border-radius:0 0 32px 32px;margin:0 -16px;padding:47px 16px 0;position:fixed;width:100vw;z-index:1020}._3zfDH{fill:#fff;height:16px;height:1.6rem;stroke:#fff;width:16px;width:1.6rem}html[dir=rtl] ._3zfDH{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.dHHrY{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;color:#fff;font-size:20px;font-size:2rem;font-weight:500;height:60px;line-height:1.4;text-align:center}.dHHrY a{color:#fff}", ""]);
// Exports
exports.locals = {
	"mobilePage": "_39tcf",
	"mobileHeader": "fhJQY",
	"mobileHeader__arrow": "_3zfDH",
	"mobileHeaderContent": "dHHrY"
};
module.exports = exports;
